import { Href } from "../../Utils/Constants";

export const bookMarkData = [
    {
        icon: "form",
        path: `${process.env.PUBLIC_URL}/forms/forms_controls/form_validation`,
        title: "Form",
        color: "primary",
    },
    {
        icon: "user",
        path: `${process.env.PUBLIC_URL}/users/user_profile`,
        title: "Profile",
        color: "secondary",
    },
    {
        icon: "table",
        path: `${process.env.PUBLIC_URL}/table/reactstrap_table/basic_table`,
        title: "Tables",
        color: "warning",
    },
];

export const cartsData = [
    {
        img: "cart-img.jpg",
        userName: "Furniture Chair for Home",
        amount: "500"
    },
    {
        img: "table-img.jpg",
        userName: "Furniture Table for Office",
        amount: "500"
    }
]

export let languageData = [
    {
        languageParameter: "en",
        languageName: "English",
        languageIconClassName: "us",
        subTitle: "US"
    },
    {
        languageParameter: "du",
        languageName: "Deutsch",
        languageIconClassName: "de",
    },
    {
        languageParameter: "es",
        languageName: "Español",
        languageIconClassName: "es",
    },
    {
        languageParameter: "fr",
        languageName: "Français",
        languageIconClassName: "fr",
    },
    {
        languageParameter: "pt",
        languageName: "Português",
        languageIconClassName: "pt",
        subTitle: "BR"
    },
    {
        languageParameter: "cn",
        languageName: "简体中文",
        languageIconClassName: "cn",
    },
    {
        languageParameter: "ae",
        languageName: "لعربي",
        languageIconClassName: "ae",
        subTitle: "ae"
    },
];

export interface profilesMessageType {
    name: string,
    icon: "User" | "Mail" | "FileText" | "Settings" | "LogOut",
    link: string
}

export const profilesMessage: profilesMessageType[] = [
    {
        name: "Account",
        icon: "User",
        link: `${process.env.PUBLIC_URL}/users/user_profile`
    },
    {
        name: "Inbox",
        icon: "Mail",
        link: `${process.env.PUBLIC_URL}/email/letter_box`
    },
    {
        name: "Taskboard",
        icon: "FileText",
        link: `${process.env.PUBLIC_URL}/app/task`
    },
    {
        name: "Settings",
        icon: "Settings",
        link: `${process.env.PUBLIC_URL}/users/user_edit`
    },
    {
        name: "Log Out",
        icon: "LogOut",
        link: `${process.env.PUBLIC_URL}/login`
    },
];

export const notificationData = [
    {
        img: "wallet.png",
        link: Href,
        title: "New daily offer added",
        subTitle: "New user-only offer added",
        color: "primary"
    },
    {
        img: "shield-dne.png",
        link: Href,
        title: "Product Evaluation",
        subTitle: "Changed to a new workflow",
        color: "info"
    },
    {
        img: "graph.png",
        link: Href,
        title: "Return of a Product",
        subTitle: "452 items were returned",
        color: "warning"
    },
    {
        img: "ticket-star.png",
        link: Href,
        title: "Recently Paid",
        subTitle: "Mastercard payment of $343",
        color: "secondary"
    }
]

export const messageData = [
    {
        img: "1.png",
        statusClass: "Hello Miss...😊",
        userName: "Hackett Yessenia",
        time: "10 min.",
        color: "primary"
    },
    {
        img: "2.png",
        statusClass: "Wishing You a Happy Birthday Dear.. 🥳🎊",
        userName: "schneider Adan",
        time: "25 min.",
        color: "secondary"
    },
    {
        img: "3.png",
        statusClass: "Hello Dear!! This Theme Is Very beautiful",
        userName: "Mahdi Gholizadeh",
        time: "1 hours",
        color: "success"
    },
];